import styles from "./add-tokens-modal.module.scss";
import { FC } from "react";

interface Props {
  closeModal?: (args: { fetchUserDetails: boolean }) => void;
  credits: number;
  user: any;
  setStep: (value: number) => void;
  handlePurchaseTokens: () => Promise<void>;
}

export const OrderSummary: FC<Props> = ({
  closeModal,
  credits,
  setStep,
  handlePurchaseTokens,
  user,
}) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <div className={styles.modalHeaderBack} onClick={() => setStep(1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            // className="bi bi-chevron-left"
            viewBox="0 0 16 16"
            className={styles.modalHeaderBackIcon}
          >
            <path
              fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
          </svg>{" "}
          Go back
        </div>
        <h3 className={styles.modalHeaderTitle}>Credit Increase Summary</h3>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => closeModal({ fetchUserDetails: false })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.4546 0.252083C10.1405 -0.0729166 9.63307 -0.0729166 9.31894 0.252083L5.38027 4.31875L1.4416 0.24375C1.12747 -0.08125 0.620035 -0.08125 0.305908 0.24375C-0.00821932 0.56875 -0.00821932 1.09375 0.305908 1.41875L4.24458 5.49375L0.305908 9.56875C-0.00821932 9.89375 -0.00821932 10.4187 0.305908 10.7437C0.620035 11.0687 1.12747 11.0687 1.4416 10.7437L5.38027 6.66875L9.31894 10.7437C9.63307 11.0687 10.1405 11.0687 10.4546 10.7437C10.7688 10.4187 10.7688 9.89375 10.4546 9.56875L6.51596 5.49375L10.4546 1.41875C10.7607 1.10208 10.7607 0.56875 10.4546 0.252083Z"
              fill="#2E2E2E"
            />
          </svg>
        </div>
      </div>
      <div className={styles.modalBody}>
        <div className={styles.modalBodyRow}>
          <p className={styles.modalBodyRowText}>Customer</p>
          <p
            className={styles.modalBodyRowText}
            style={{ textAlign: "center" }}
          >
            Description
          </p>
          <p className={styles.modalBodyRowText} style={{ textAlign: "end" }}>
            Amount
          </p>
        </div>
        <div className={styles.modalBodyRow}>
          <p className={styles.modalBodyRowText}>{user?.name}</p>
          <p
            className={styles.modalBodyRowText}
            style={{ textAlign: "center" }}
          >
            Credits increase
          </p>
          <p className={styles.modalBodyRowText} style={{ textAlign: "end" }}>
            {credits} credits
          </p>
        </div>
        <div className={styles.modalBodyTotal}>
          <p className={styles.modalBodyTotalText}>Total</p>
          <p className={styles.modalBodyTotalTextBold}>{credits} credits</p>
        </div>
      </div>
      <div className={styles.modalButtonWrap}>
        <button
          className={styles.modalButtonCancel}
          onClick={() => closeModal({ fetchUserDetails: false })}
        >
          Cancel
        </button>
        <button
          className={styles.modalButton}
          onClick={() => {
            handlePurchaseTokens();
          }}
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};
